import { Component } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { OrganisationService } from '../../services/organisation.service';

@Component({
  selector: 'app-info-bar',
  templateUrl: './info-bar.component.html',
  styleUrl: './info-bar.component.scss',
})
export class InfoBarComponent {
  constructor(
    protected organisationService: OrganisationService,
    protected authService: AuthService
  ) {}

  get showTrialBar() {
    return this.organisationService.organisation?.plan_name === 'trial';
  }

  get showImpersonationBar() {
    return this.authService.accessTokenPayload$.value?.impersonating === true;
  }

  get expiringDays() {
    const subEnd = new Date(
      this.organisationService.organisation?.subscription_end_date!
    );
    return Math.floor((subEnd.getTime() - Date.now()) / (1000 * 60 * 60 * 24));
  }

  stopImpersonate() {
    this.authService.stopImpersonate().subscribe();
  }
}
